<!--
 * @Description: 设备管理-视频监控
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2021-10-12 11:04:03
 * @LastEditTime: 2022-09-28 15:10:18
-->
<template>
  <div id="VideoMonitor">
    <!-- 站点树形数据 -->
    <div class="treeAside">
      <div class="treeBox">
        <el-tree
          lazy
          :load="loadData"
          :props="props"
          v-if="1"
          class="tree"
          ref="tree"
          :indent="6"
          node-key="value"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree>
        <!-- <el-tree v-if="1" class="tree" :indent=6 :data="treeData" how-checkbox node-key="value" default-expand-all highlight-current :expand-on-click-node="false" @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree> -->
      </div>
    </div>
    <!-- 视频区域 -->
    <div class="videoContent">
      <!-- 画面操作相关 -->
      <div class="videoNumSwitch">
        <!-- 清除视频 -->
        <div class="clearVideo" @click="destorySinglePlayer(videoSelectActive)">
          <i class="el-icon-delete page-icon"></i>
          <span class="title">清除当前</span>
        </div>
        <div class="clearVideo"  @click="destoryAllPlayer">
          <i class="el-icon-close page-icon"></i>
          <span class="title">全部清除</span>
        </div>
        <!-- 画面布局切换 -->
        <div
          :class="switchActive === index ? 'switchItem active' : 'switchItem'"
          v-for="(item,index) in switchData"
          :key="index"
          @click="videoNumSwitch(index)">
          <span :class="item.icon"> {{item.name}}</span>
        </div>
      </div>
      <!-- 监控画面 -->
      <div class="videos">
        <div
          :class="videoSelectActive === index ? 'videoItem active' : 'videoItem'"
          v-for="(video,index) in videoItemConfig"
          :key="index"
          :style="layoutStyle"
          :id="video.videoContainerId"
          v-show="index < videoNum"
          @click="selectVideo(index)">
            <div class='noVideo'><i class="el-icon-video-camera iconbofang"></i><span class='noVideoText'>请添加监控视频</span></div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getSiteInfoList } from './service.js'
// import { getDicList } from '@/services'
export default {
  name: 'VideoMonitor',
  components: {
  },
  data () {
    return {
      treeData: [],
      // 布局切换配置数据
      switchData: [
        {
          name: '单画面',
          icon: 'iconfont icondaojiaozhengfangxing',
        },
        {
          name: '四画面',
          icon: 'iconfont iconsquare_grid_2x2_fill',
        },
        {
          name: '九画面',
          icon: 'iconfont iconjiugongge',
        },
      ],
      // 当前激活的布局tab索引
      switchActive: 1,
      // 视频实例初始化配置数据 容器id videoid
      videoItemConfig: [
        {
          videoContainerId: 'videoContainer0',
          videoId: 'video0',
        },
        {
          videoContainerId: 'videoContainer1',
          videoId: 'video1',
        },
        {
          videoContainerId: 'videoContainer2',
          videoId: 'video2',
        },
        {
          videoContainerId: 'videoContainer3',
          videoId: 'video3',
        },
        {
          videoContainerId: 'videoContainer4',
          videoId: 'video4',
        },
        {
          videoContainerId: 'videoContainer5',
          videoId: 'video5',
        },
        {
          videoContainerId: 'videoContainer6',
          videoId: 'video6',
        },
        {
          videoContainerId: 'videoContainer7',
          videoId: 'video7',
        },
        {
          videoContainerId: 'videoContainer8',
          videoId: 'video8',
        },
      ],
      // 当前选择的视频索引
      videoSelectActive: 0,
      // 默认布局样式
      layoutStyle: 'width: 49.5%;height:49.2%;',
      // 当前切换布局的播放器数量
      videoNum: 4,
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      }
    }
  },
  methods: {
    /**
     * @description: 监控视频画面布局切换
     * @param {Number} 当前切换tab的索引
     * @return {undefined} 无返回值
     */
    videoNumSwitch (index) {
      this.switchActive = index
      switch (index) {
        case 0:
          this.videoNum = 1
          this.layoutStyle = 'width: 99.6%;height:99.4%;'
          break
        case 1:
          this.videoNum = 4
          this.layoutStyle = 'width: 49.5%;height:49.2%;'
          break
        case 2:
          this.videoNum = 9
          this.layoutStyle = 'width: 33%;height:32.8%;'
          break
      }
    },
    /**
     * @description: 视频选中
     * @param {Number} 当前选中视频的索引
     * @return {undefined} 无返回值
     */
    selectVideo (index) {
      this.videoSelectActive = index
    },
    /**
     * @description: 初始化视频
     * @param {String} 视频链接
     * @param {Number} 选中要播放视频的框的索引
     * @return {undefined} 无返回值
     */
    initVideo (src, videoSelectIndex) {
      if (this.videoItemConfig[videoSelectIndex].videoInstance) this.destorySinglePlayer(videoSelectIndex)

      let videoContainerId = this.videoItemConfig[videoSelectIndex].videoContainerId
      let videoId = this.videoItemConfig[videoSelectIndex].videoId

      document.getElementById(videoContainerId).innerHTML = '<video id=' + videoId + " class='video-js videoItem vjs-default-skin' preload='auto' autoplay controls><source src=" + src + " type='application/x-mpegURL' /></video>"

      // eslint-disable-next-line no-undef
      this.videoItemConfig[videoSelectIndex].videoInstance = videojs(videoId, {}, function onPlayerReady () {
        this.hotkeys({
          volumeStep: 0.1,
          seekStep: 5,
          enableVolumeScroll: false,
          enableModifiersForNumbers: false,
        })
        this.play()
        this.on('ended', function () {
          console.log('ended, video js')
        })
      })
    },
    /**
     * @description: 销毁单个视频实例
     * @param {Number} 视频实例索引
     * @return {undefined} 无返回值
     */
    destorySinglePlayer (index) {
      if (this.videoItemConfig[index].videoInstance) {
        this.videoItemConfig[index].videoInstance.dispose()
        this.videoItemConfig[index].videoInstance = null
      }
      document.getElementById(this.videoItemConfig[index].videoContainerId).innerHTML = "<div class='noVideo'><i class='el-icon-video-camera iconbofang'></i><span class='noVideoText'>请添加监控视频</span></div>"
    },
    /**
     * @description: 销毁所有视频实例
     * @param {Undefined} 无
     * @return {undefined} 无返回值
     */
    destoryAllPlayer () {
      this.videoItemConfig.map(item => {
        if (item.videoInstance) {
          item.videoInstance.dispose()
          item.videoInstance = document.getElementById(item.videoContainerId).innerHTML = "<div class='noVideo'><i class='el-icon-video-camera iconbofang'></i><span class='noVideoText'>请添加监控视频</span></div>"
        }
      })
    },

    // 查询组织
    queryTreeNode(pid = 0) {
      this.request.get(`/front/system/organization/findTreeById?id=${pid}`)
        .then(rs => {

          this.treeData = rs.code === 200 ? rs.data : [];
          this.currentTreeId = this.treeData.length > 0 ? this.treeData[0].value : 0;
        })
        .catch(error => (this.treeData = []));
    },
    // 查询区域
    loadData (node, resolve) {
      if (node.level === 0) {
        let root = { id: 0, label: '区域机构', parentId: 0, value: 0 }
        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreefenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []

          // 区域-终端出库设备
          if (node.level == 1) {
            data.unshift({ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true })
          }

          resolve(data)
          
        }).catch(error => {
          console.error(error)
          let temp = node.level == 1 ? [{ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true }] : []
          resolve(temp)
        })        
      }
    },    
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      // this.initVideo('https://live-3a16.aliplus.com/live/SI0rjiaVfIuEC_npncdfymFrlfYP-a86XaQsjU7mwsI_0.m3u8?token=e7eced17f6f64392be4a57b802110881&session=1f1d732238f340bd99c190c84799d364', this.videoSelectActive)
      this.request.get('/front/device/camera/1').then(res => {
        if (res.code === 200) {
          res.data && this.initVideo(res.data, this.videoSelectActive)
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },   
  },
  beforeDestroy () {
    this.destoryAllPlayer()
  },
  created () {
    // this.queryTreeNode()
  },
}
</script>

<style lang="scss">
  #VideoMonitor {
    width: 100%;
    height: calc(100% - 38px);
    min-height: 600px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    user-select: none;

    .treeAside {
      // border: 1px solid red;
      position: relative;
      width: 230px;
      height: 100%;
      padding: 0px 5px;
      // left: 0;
      // top: 0;
      box-sizing: border-box;

      .treeBox {
        overflow: hidden;
        height: 100%;
        // border: 1px solid #ebeef5;
        padding: 50px 0 10px;
        box-sizing: border-box;
      }

      .tree {
        height: 100%;
        overflow: auto;

        .el-tree-node__content {
          height: 40px;
        }

        .custom-tree-node {
          height: 40px;
          line-height: 40px;
          width: 100%;

          .treeLabel {
            font-size: 14px;
            display: inline-block;
            width: 130px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .treeBtn {
            float: right;

            .el-button {
              margin-left: 0;
            }
          }
        }
      }
    }

    .videoContent {
      width:calc(100% - 230px);
      height: 100%;

      .videoNumSwitch {
        width: 98%;
        height: 34px;
        text-align: right;
        padding: 8px 0;

        .clearVideo {
          display: inline-block;
          cursor: pointer;
          color: #999;
          margin-right: 50px;
          border-radius: 4px;
          padding: 4px;
          font-size: 12px;

          &:hover {
            color: #777;
          }

          .page-icon {
            vertical-align: middle;
            font-size: 18px;
            color: #F56C6C;
            margin-right: 4px;
          }

          span {
            vertical-align: middle;
          }
        }

        .switchItem {
          display: inline-block;
          border: 1px solid #999;
          border-radius: 4px;
          padding: 8px 15px;
          margin-left: 10px;
          color: #999;
          cursor: pointer;
        }

        .active {
          border: 1px solid #217DEA;
          color: #217DEA;
        }
      }

      .videos {
        width: 100%;
        height: calc(100% - 50px);
        display: flex;
        justify-content: space-around;
        align-content: space-around;
        flex-wrap: wrap;
        // background: #000;
        overflow: hidden;
        .videoItem {
          width: 32%;
          height: 32%;
          background: rgb(52, 52, 52);
          transition: all 0.5s;

          .noVideo {
            text-align: center;
            // border: 1px solid red;
            margin-top: 20%;
            .iconbofang {
              font-size: 40px;
              color: #dfdfdf;
            }

            .noVideoText {
              display: block;
              font-size: 16px;
              color: #dfdfdf;
            }
          }

          .video-js {
            width: 100%;
            height: 100%;

            .vjs-tech {
              width: 100%;
              height: 100%;
              pointer-events: none;
            }

            .vjs-control-bar {
              .vjs-play-control {
                display: none;
              }
            }
          }
        }

        .active {
          // box-shadow: 0 0 0 4px #1EA6B1;
          box-shadow: 0 0 0 4px #FF8C00;
        }
      }
    }
  }
</style>
